import Vue from "vue";
import VueCookies from "vue-cookies";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/validate";
import { router } from "./router";
import { i18n } from "./plugins/i18n";
import store from "./store";
import LoadScript from "vue-plugin-load-script";
import * as moment from "moment";

// apostrophe-workflow uses lodash < 4, generate fallback functions
const _ = require("lodash");
_.contains = _.includes;
_.pluck = _.map;

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(LoadScript);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.filter("formatDate", (value) =>
  value != null && value.length ? moment(value).format("DD.MM.YYYY") : ""
);

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
